import styled from 'styled-components';

export const CardListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const SearchWrapper = styled.div`
  display: flex;
  margin: 20px;
  align-items: center;
`;
